import { Directive, ElementRef, inject, input, OnInit, Renderer2 } from '@angular/core';
import { PermissionService } from '../../authentication/service/permissionService';

@Directive({
  selector: '[appPermission]',
})
export class PermissionsDirective implements OnInit {
  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly permissionService = inject(PermissionService);

  readonly referenceID = input<string | null>(null);
  readonly feature = input.required<string>();
  readonly actions = input.required<string[]>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  async ngOnInit(): Promise<void> {
    const canPerformAction = await this.permissionService.checkPermission(
      this.referenceID(),
      this.feature(),
      this.actions()
    );
    if (!canPerformAction) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
    }
  }
}
